exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.placeholder[data-v-6e741f88] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  /*flex-wrap: wrap;*/\n  height: 100%;\n  width: 100%;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.placeholder__inner[data-v-6e741f88] {\n  width: 200px;\n  height: 200px;\n  max-width: 100%;\n}\n.launch-screen[data-v-6e741f88] {\n  background-color: #5b5b5b;\n}\n.launch-screen[data-v-6e741f88] {\n  background-color: white;\n  background: radial-gradient(ellipse at center, white 0%, #f6f6f6 47%, #ededed 100%);\n}\n.carrier__image[data-v-6e741f88] {\n  max-width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-6e741f88","scoped":true,"hasInlineConfig":false}!./~/sass-loader?{}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/components/launch-screen.page.vue
// module id = 629
// module chunks = 0